import { render, staticRenderFns } from "./ShowImageInCard.vue?vue&type=template&id=91b6bf32&scoped=true"
import script from "./ShowImageInCard.vue?vue&type=script&lang=js"
export * from "./ShowImageInCard.vue?vue&type=script&lang=js"
import style0 from "./ShowImageInCard.vue?vue&type=style&index=0&id=91b6bf32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b6bf32",
  null
  
)

export default component.exports